module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/514e6c5a07dde1ec563dea1c9f37f7a8.gif";